import Vue from 'vue';

export function renderComponent(component, config = {}, slots = []) {
  return new Vue({
    render: h =>
      h(
        component,
        config,
        slots.map(slot => h(slot.component, slot.props))
      ),
  });
}

export function appendComponent(component, el, config = {}, slots = []) {
  const vnode = renderComponent(component, config, slots);
  el.appendChild(vnode.$mount().$el);

  return vnode;
}
